import { useMutation, useQueryClient } from '@tanstack/react-query';
import { produce } from 'immer';
import { userInfoQueryOptions } from '@/hooks/users/use-user-info';
import type { RespondedType, ResponseError } from '@/models/response';
import { addToast } from '@/stores/toast';
import { fetcher } from '@/utils/fetcher';

export default function useUpdateUserSign() {
  const queryClient = useQueryClient();

  return useMutation<RespondedType, ResponseError, Nullable<string>>({
    mutationKey: ['/UpdateUserSign'],
    mutationFn: (params) => fetcher('/UpdateUserSign', { Sign: params }, { validResponseCodes: [0] }),
    onSuccess: (_, params) => {
      queryClient.setQueryData(userInfoQueryOptions.queryKey, (data) =>
        produce(data, (draft) => {
          if (!draft) return draft;
          draft.Sign = params ?? '';
        }),
      );
    },
    onSettled: (data, error) =>
      addToast({
        type: data ? 'success' : 'error',
        message: data?.Msg ?? error?.message,
      }),
  });
}
